import { initializeApp } from 'firebase/app';
import { initializeFirestore, memoryLocalCache } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyD0DiZGv4aF0E1mbU-d8_IBHHFDM3Prd0A",
  authDomain: "slaaploods-verlofbeheer.firebaseapp.com",
  projectId: "slaaploods-verlofbeheer",
  storageBucket: "slaaploods-verlofbeheer.firebasestorage.app",
  messagingSenderId: "1085600710767",
  appId: "1:1085600710767:web:783ee89ef2f44043de8d9a"
};

const app = initializeApp(firebaseConfig);
// Gebruik memory cache i.p.v. IndexedDB persistent cache (voorkomt ~90MB lokale opslag)
export const db = initializeFirestore(app, { localCache: memoryLocalCache() });
export default app;
